<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-profile-page" style="margin-bottom: 50px;">

  <!-- TOP BLACK AREA -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <button class="appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="appbar-title">{{ "Profile" | transloco }}</h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- MAIN CONTENT -->
  <div class="vcash-content">

    <!-- BALANCE CARD -->
    <section class="balance-card">
      <div class="balance-card__top">
        <div class="balance-main">
          <span class="balance-overline">{{ "welcome" | transloco }}</span>
          <h2>{{ userfirstname }}</h2>
          <p>{{ userPhone }}</p>
        </div>

        <div class="cashback-box" routerLink="/wallet">
          <span class="cashback-label">{{ "wallet" | transloco }}</span>
          <strong>{{ balance }} {{ "egpe" | transloco }}</strong>
        </div>
      </div>

      <div class="balance-card__bottom">
        <div class="mini-action" routerLink="/address">
          <div class="mini-action__icon">
            <img src="/assets/e-commerce/icons/54.webp" alt="addresses" />
          </div>
          <div class="mini-action__text">
            <span>{{ "myaddresses" | transloco }}</span>
          </div>
        </div>

        <div class="mini-action" routerLink="/notifications">
          <div class="mini-action__icon">
            <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
          </div>
          <div class="mini-action__text">
            <span>{{ "notification" | transloco }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- WIDE ACTION ROW -->
    <section class="wide-action-card" routerLink="/change-password">
      <div class="wide-action-card__left">
        <div class="wide-action-card__icon">
          <img src="/assets/e-commerce/icons/51.webp" alt="password" />
        </div>
        <span>{{ "Change Password" | transloco }}</span>
      </div>

      <div class="wide-action-card__right">
        <img [src]="isAr ? '/assets/e-commerce/icons/61.webp' : '/assets/e-commerce/icons/60.webp'" alt="arrow" />
      </div>
    </section>

    <!-- 3 QUICK CARDS -->
    <section class="quick-cards-wrap">
      <div class="quick-cards-strip"></div>

      <div class="quick-cards-row">
        <div class="quick-card" routerLink="/wallet">
          <div class="quick-card__icon">
            <img src="/assets/e-commerce/icons/53.webp" alt="wallet" />
          </div>
          <div class="quick-card__title">{{ "wallet" | transloco }}</div>
        </div>

        <div class="quick-card" (click)="toggleLanguage()">
          <div class="quick-card__icon">
            <img src="/assets/e-commerce/icons/59.webp" alt="language" />
          </div>
          <div class="quick-card__title">{{ "changelang" | transloco }}</div>
        </div>

        <div class="quick-card" routerLink="/contact-us">
          <div class="quick-card__icon">
            <img src="/assets/e-commerce/icons/64.webp" alt="contact" />
          </div>
          <div class="quick-card__title">{{ "Contact Us" | transloco }}</div>
        </div>
      </div>
    </section>

    <!-- SERVICES GRID -->
    <section class="services-section">
      <div class="services-header">
        <h3>{{ "Profile" | transloco }}</h3>

      </div>

      <div class="services-grid">
        <div class="service-item" routerLink="/about-us">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/63.webp" alt="about" />
          </div>
          <span>{{ "About Us" | transloco }}</span>
        </div>

        <div class="service-item" routerLink="/refund-policy">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/88.webp" alt="refund" />
          </div>
          <span>{{ "refund" | transloco }}</span>
        </div>

        <div class="service-item" routerLink="/notifications">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
          </div>
          <span>{{ "notification" | transloco }}</span>
        </div>

        <div class="service-item" routerLink="/address">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/54.webp" alt="addresses" />
          </div>
          <span>{{ "myaddresses" | transloco }}</span>
        </div>

        <div class="service-item" routerLink="/wallet">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/53.webp" alt="wallet" />
          </div>
          <span>{{ "wallet" | transloco }}</span>
        </div>

        <div class="service-item" routerLink="/contact-us">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/89.webp" alt="contact" />
          </div>
          <span>{{ "Contact Us" | transloco }}</span>
        </div>

        <div class="service-item" routerLink="/change-password">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/51.webp" alt="password" />
          </div>
          <span>{{ "Change Password" | transloco }}</span>
        </div>

        <div class="service-item service-item--logout" (click)="logout()">
          <div class="service-item__icon">
            <img src="/assets/e-commerce/icons/87.webp" alt="logout" />
          </div>
          <span>{{ "Log out" | transloco }}</span>
        </div>
      </div>
    </section>

  </div>
</div>